import { useEffect } from 'react'

import { useDispatch } from 'react-redux'
import { useRouteMatch } from 'react-router'

import { matchCouplePath } from 'components/page/RatingWave/Rating.paths'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { push } from 'functions/router'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const useNavigateCoupleMatching = () => {
  const dispatch = useDispatch()
  const { match } = useShallowEqualSelector(({ match }) => ({ match }))
  const { url } = useRouteMatch()

  useEffect(() => {
    if (match.initiatorPhotoId && match.matcherPhotoId) {
      dispatch(push(mergeAllUrls(url, matchCouplePath)))
    }
  }, [dispatch, match, url])
}
